import "./InventoryQuery.css";
import { randomUUID, regUses } from "../../axios_with_token";
import { useRcds, useTbl, addTblRcds} from "../../axios_with_token";
import { useRcdList } from "../../input_types/Tbl/Tbl";
import WWTabs from "../../components/WWTabs/WWTabs";
import Tbl from "../../input_types/Tbl/Tbl";
import { useDialog } from "../../input_types/Dialog/Dialog";
import { useState } from "react";
import Search from "../../widgets/Search/Search";
import { useForm } from "react-hook-form";
import { getUserInfo, delTblRcds } from "../../axios_with_token";

import LoginProvider, { useLoginContext } from "../../Login/Login";



export function useInvStatus({}){
    const {regUse, DefaultResponse, isReady, isLoading, hasError, errors} = regUses()

    const {data:invChkItms, invalidate:invalidateInvChkItms} = regUse(useRcds('inventoryCheckItems',
        false,
        100000, 
        {
            __commonFlds: 'forId',
            __commonFilters: '2'   
        }
    ));
    const {data:tblPdts, invalidate:invalidateTblPdts} = regUse(useTbl('pdts'));
    const {data:tblPoses, invalidate:invalidateTblPoses} = regUse(useTbl('poses'));
    const pdtsStatus = {};
    const posesStatus = {};
    const skidIdToPos = {};
    const arrInvChkItms = ((invChkItms||{}).rcds||[]);
    // we want posStatus to be recalculated without update the root component
    if(isReady()){
        tblPoses.rcds.forEach(rcdPos=>{
            skidIdToPos[rcdPos.skidId] = rcdPos;
        })
        arrInvChkItms.forEach(chkItm=>{
            const pdtInfo = tblPdts.rcdsById[chkItm.pdtId] || {};
            if(!pdtsStatus[chkItm.pdtId]){
                pdtsStatus[chkItm.pdtId] = {};
                pdtsStatus[chkItm.pdtId]['pdtName'] = `[${chkItm.pdtId}] ${pdtInfo.sn}-${pdtInfo.name}-${pdtInfo.brandAbbr}`;
                pdtsStatus[chkItm.pdtId]['qty'] = 0;
                pdtsStatus[chkItm.pdtId]['chkItms'] = [];
            }
            pdtsStatus[chkItm.pdtId]['qty'] += eval(chkItm.qty) * (chkItm.unit == 'DZ'?12:1);
            pdtsStatus[chkItm.pdtId]['chkItms'].push(chkItm);

            const posInfo = skidIdToPos[chkItm.skidId] || {};
            if(!posesStatus[posInfo.__id]){
                posesStatus[posInfo.__id] = {};
                posesStatus[posInfo.__id]['posInfo'] = posInfo;
                posesStatus[posInfo.__id]['chkItms'] = [];
            }
            posesStatus[posInfo.__id]['chkItms'].push(chkItm);
        })
    }

    const flds = 'pdtName,pdtQty'.split(',');

    function getPdtCaption(pdtRcd){
        return `[${pdtRcd.__id}] ${pdtRcd.sn}-${pdtRcd.name}-${pdtRcd.brandAbbr}`;
    }

    function MoveSkid({srcPosId, chkItmId, refreshPositionList, closeDialog}){
        const form = useForm();

        return <div>
            <Search
                fldName={"__id"}
                form={form}
                fldDef={{
                    srcTbl: 'poses',
                    srcShowFlds: 'sn',
                    srcSearchFlds: 'sn'
                }}
                opts={{}}
            ></Search>
            <button
                className="btn btn-primary btn-sm"
                type="button"
                onClick={evt=>{
                    const tgtPosId = form.getValues()['__id'];
                    if(tgtPosId == srcPosId){
                        alert('target is the same position.');
                        return;
                    }

                    const srcPos = tblPoses.rcdsById[srcPosId];
                    const tgtPos = tblPoses.rcdsById[tgtPosId];
                    if(tgtPos.skidId?window.alert(`Target position has skid [${tgtPos.skidId}]`) || window.confirm(`Confirm to move skid at [${srcPos.sn} / ${srcPos.skidId}] to [${tgtPos.sn} / ${tgtPos.skidId}] and unregister skid at target position?`)
                        :window.confirm(`confirm to move skid at [${srcPos.sn} / ${srcPos.skidId}] to [${tgtPos.sn} / ${tgtPos.skidId}]?`)
                    ){
                        addTblRcds('poses',[
                            {
                                __id: srcPos.__id,
                                skidId: ''
                            },
                            {
                                __id: tgtPos.__id,
                                skidId: srcPos.skidId
                            },
                        ]).then(r=>{
                            refreshPositionList();
                            closeDialog&&closeDialog();
                            alert('move skid done.');
                        })
                    }
                }}
            >move</button>
        </div>

    }

    function MovePdt({chkItmId, closeDialog, refreshPositionList, invalidatePosesList}){
        const form = useForm();

        return <div>
            <Search
                fldName={"__id"}
                form={form}
                fldDef={{
                    srcTbl: 'poses',
                    srcShowFlds: 'sn',
                    srcSearchFlds: 'sn'
                }}
                opts={{}}
            ></Search>
            <button
                className="btn btn-primary btn-sm"
                type="button"
                onClick={evt=>{
                    const tgtPosId = form.getValues()['__id'];
                    const tgtPos = tblPoses.rcdsById[tgtPosId];
                    if(tgtPos.skidId || (!tgtPos.skidId&&window.confirm(`no skid at position [${tgtPos.sn}]. create one?`))){
                        let tgtSkidId = tgtPos.skidId;
                        Promise.all([tgtSkidId?tgtSkidId:(_=>{
                            tgtSkidId = `skidid-${randomUUID()}`;
                            return addTblRcds('poses',[
                                {
                                    __id: tgtPosId,
                                    skidId: tgtSkidId
                                }
                            ]);
                        })()]).then(r=>addTblRcds(
                            'inventoryCheckItems',
                            [
                                {
                                    __id: chkItmId,
                                    skidId: tgtSkidId
                                }
                            ]
                        )).then(r=>{
                            // invalidateTblPoses();
                            invalidateInvChkItms();
                            // refreshPositionList();
                            invalidatePosesList();
                            alert('move product done.');
                            closeDialog&&closeDialog();
                        }).catch(err=>console.log(err));
                        
                    }
                }}
            >move</button>
        </div>

    }

    return {
        data:{
            pdtsStatus,
            posesStatus,
            skidIdToPos,
            arrInvChkItms,
            getPdtCaption,

            tblPoses,
            tblPdts,

            MoveSkid,
            MovePdt
        },
        loading: isLoading(),
        error: errors,

        // hasError,
        // isReady,
        // DefaultResponse
    }

}


function InventoryQueryContent({}){
    const [activeTag, setActiveTag] = useState()

    // // get 
    // const {regUse, DefaultResponse, isReady} = regUses()
    // const {data:invChkItms, invalidate:invalidateInvChkItms} = regUse(useRcds('inventoryCheckItems',
    //     false,
    //     100000, 
    //     {
    //         __commonFlds: 'forId',
    //         __commonFilters: '2'   
    //     }
    // ));
    // const {data:tblPdts, invalidate:invalidateTblPdts} = regUse(useTbl('pdts'));
    // const {data:tblPoses, invalidate:invalidateTblPoses} = regUse(useTbl('poses'));
    // const pdtsStatus = {};
    // const posesStatus = {};
    // const skidIdToPos = {};
    // const arrInvChkItms = ((invChkItms||{}).rcds||[]);
    // // we want posStatus to be recalculated without update the root component
    // if(isReady()){
    //     tblPoses.rcds.forEach(rcdPos=>{
    //         skidIdToPos[rcdPos.skidId] = rcdPos;
    //     })
    //     arrInvChkItms.forEach(chkItm=>{
    //         const pdtInfo = tblPdts.rcdsById[chkItm.pdtId] || {};
    //         if(!pdtsStatus[chkItm.pdtId]){
    //             pdtsStatus[chkItm.pdtId] = {};
    //             pdtsStatus[chkItm.pdtId]['pdtName'] = `[${chkItm.pdtId}] ${pdtInfo.sn}-${pdtInfo.name}-${pdtInfo.brandAbbr}`;
    //             pdtsStatus[chkItm.pdtId]['qty'] = 0;
    //             pdtsStatus[chkItm.pdtId]['chkItms'] = [];
    //         }
    //         pdtsStatus[chkItm.pdtId]['qty'] += eval(chkItm.qty) * (chkItm.unit == 'DZ'?12:1);
    //         pdtsStatus[chkItm.pdtId]['chkItms'].push(chkItm);

    //         const posInfo = skidIdToPos[chkItm.skidId] || {};
    //         if(!posesStatus[posInfo.__id]){
    //             posesStatus[posInfo.__id] = {};
    //             posesStatus[posInfo.__id]['posInfo'] = posInfo;
    //             posesStatus[posInfo.__id]['chkItms'] = [];
    //         }
    //         posesStatus[posInfo.__id]['chkItms'].push(chkItm);
    //     })
    // }

    // const flds = 'pdtName,pdtQty'.split(',');

    // function getPdtCaption(pdtRcd){
    //     return `[${pdtRcd.__id}] ${pdtRcd.sn}-${pdtRcd.name}-${pdtRcd.brandAbbr}`;
    // }

    // function MoveSkid({srcPosId, chkItmId, refreshPositionList, closeDialog}){
    //     const form = useForm();

    //     return <div>
    //         <Search
    //             fldName={"__id"}
    //             form={form}
    //             fldDef={{
    //                 srcTbl: 'poses',
    //                 srcShowFlds: 'sn',
    //                 srcSearchFlds: 'sn'
    //             }}
    //             opts={{}}
    //         ></Search>
    //         <button
    //             className="btn btn-primary btn-sm"
    //             type="button"
    //             onClick={evt=>{
    //                 const tgtPosId = form.getValues()['__id'];
    //                 if(tgtPosId == srcPosId){
    //                     alert('target is the same position.');
    //                     return;
    //                 }

    //                 const srcPos = tblPoses.rcdsById[srcPosId];
    //                 const tgtPos = tblPoses.rcdsById[tgtPosId];
    //                 if(tgtPos.skidId?window.alert(`Target position has skid [${tgtPos.skidId}]`) || window.confirm(`Confirm to move skid at [${srcPos.sn} / ${srcPos.skidId}] to [${tgtPos.sn} / ${tgtPos.skidId}] and unregister skid at target position?`)
    //                     :window.confirm(`confirm to move skid at [${srcPos.sn} / ${srcPos.skidId}] to [${tgtPos.sn} / ${tgtPos.skidId}]?`)
    //                 ){
    //                     addTblRcds('poses',[
    //                         {
    //                             __id: srcPos.__id,
    //                             skidId: ''
    //                         },
    //                         {
    //                             __id: tgtPos.__id,
    //                             skidId: srcPos.skidId
    //                         },
    //                     ]).then(r=>{
    //                         refreshPositionList();
    //                         closeDialog&&closeDialog();
    //                         alert('move skid done.');
    //                     })
    //                 }
    //             }}
    //         >move</button>
    //     </div>

    // }

    // function MovePdt({chkItmId, closeDialog, refreshPositionList, invalidatePosesList}){
    //     const form = useForm();

    //     return <div>
    //         <Search
    //             fldName={"__id"}
    //             form={form}
    //             fldDef={{
    //                 srcTbl: 'poses',
    //                 srcShowFlds: 'sn',
    //                 srcSearchFlds: 'sn'
    //             }}
    //             opts={{}}
    //         ></Search>
    //         <button
    //             className="btn btn-primary btn-sm"
    //             type="button"
    //             onClick={evt=>{
    //                 const tgtPosId = form.getValues()['__id'];
    //                 const tgtPos = tblPoses.rcdsById[tgtPosId];
    //                 if(tgtPos.skidId || (!tgtPos.skidId&&window.confirm(`no skid at position [${tgtPos.sn}]. create one?`))){
    //                     let tgtSkidId = tgtPos.skidId;
    //                     Promise.all([tgtSkidId?tgtSkidId:(_=>{
    //                         tgtSkidId = `skidid-${randomUUID()}`;
    //                         return addTblRcds('poses',[
    //                             {
    //                                 __id: tgtPosId,
    //                                 skidId: tgtSkidId
    //                             }
    //                         ]);
    //                     })()]).then(r=>addTblRcds(
    //                         'inventoryCheckItems',
    //                         [
    //                             {
    //                                 __id: chkItmId,
    //                                 skidId: tgtSkidId
    //                             }
    //                         ]
    //                     )).then(r=>{
    //                         // invalidateTblPoses();
    //                         invalidateInvChkItms();
    //                         // refreshPositionList();
    //                         invalidatePosesList();
    //                         alert('move product done.');
    //                         closeDialog&&closeDialog();
    //                     }).catch(err=>console.log(err));
                        
    //                 }
    //             }}
    //         >move</button>
    //     </div>

    // }
    

    // const userInfo = getUserInfo();
    const {userInfo} = useLoginContext();
    return <div>
        <div className="container">
        <h1>inventory query</h1>
            <WWTabs
                onTagClick={({caption})=>{
                    setActiveTag(caption)
                }}
                tabDefs={[
                    {
                        caption: 'Summary',
                        active: activeTag == 'Summary',
                        Content: function InventorySummary({}){
                            const {regUse, DefaultResponse} = regUses();
                            const {data:useInvStatusData} = regUse(useInvStatus({}))
                            const {
                                    pdtsStatus,
                                    posesStatus,
                                    skidIdToPos,
                                    arrInvChkItms,
                                    getPdtCaption,
                                    tblPoses,
                                    tblPdts,

                                    MoveSkid,
                                    MovePdt

                            } = useInvStatusData || {};




                            return <div className="row">
                                {/* <div>{JSON.stringify((tblPdts||{}).rcdsById)}</div> */}
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>No.</th>
                                            <th>product</th>
                                            <th>quantity (pc)</th>
                                            <th>quantity (dz)</th>

                                            {/* {flds.map(fld=><th
                                                key={fld}
                                            >{fld}</th>)} */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Object.values(pdtsStatus).map((pdtInfo, idx)=><tr
                                            key={pdtInfo.pdtName}
                                        >
                                            <td>{idx+1}</td>
                                            <td>{pdtInfo.pdtName}</td>
                                            <td>{pdtInfo.qty}</td>
                                            <td>{pdtInfo.qty/12}</td>
                                        </tr>)}
                                    </tbody>
                                </table>
                            </div>
                        }
                    },
                    {
                        caption: 'Query Product',
                        active: activeTag == 'Query Product',
                        Content: function ContentQueryProduct({}){
                            const {regUse, DefaultResponse} = regUses();
                            const {data:useInvStatusData} = regUse(useInvStatus({}))
                            const {
                                    pdtsStatus,
                                    posesStatus,
                                    skidIdToPos,
                                    arrInvChkItms,
                                    getPdtCaption,
                                    tblPoses,
                                    tblPdts,

                                    MoveSkid,
                                    MovePdt

                            } = useInvStatusData || {};


                            const [rcdId, setRcdId] = useState(0);

                            const {Dialog: DlgPdtInventory, openDialog:openDlgPdtInventory, closeDialog:closeDlgPdtInventory} = useDialog({
                                dlgTitle: 'product inventory'
                            });

                            function PdtInventory({pdtId}){
                                const pdtInfo = pdtsStatus[pdtId];
                                const pdtRcd = tblPdts.rcdsById[pdtId] || {};
                                const pdtName = getPdtCaption(pdtRcd);
                                return !pdtInfo?<p>No inventory of <strong>[ {pdtName} ]</strong>.</p>:<div>
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>product name</th>
                                                <th>quantity (pc)</th>
                                                <th>quantity (dz)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{pdtInfo.pdtName}</td>
                                                <td>{pdtInfo.qty||0}</td>
                                                <td>{(pdtInfo.qty||0)/12}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <h3>product inventory positions</h3>
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>check id</th>
                                                <th>warehouse position</th>
                                                <th>quantity (pc)</th>
                                                <th>quantity (dz)</th>
                                                <td>batch</td>
                                                <td>origin</td>
                                                <th>action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {pdtInfo.chkItms.map((chkItm, chkItmIdx)=><tr
                                                key={chkItm.__id}
                                            >
                                                <td>{chkItm.forId}</td>
                                                <td>{skidIdToPos[chkItm.skidId].sn}</td>
                                                <td>{eval(chkItm.qty)*(chkItm.unit=='DZ'?12:1)}</td>
                                                <td>{eval(chkItm.qty)/(chkItm.unit=='PC'?12:1)}</td>
                                                <td>{chkItm.batch}</td>
                                                <td>{chkItm.origin}</td>
                                                <td>
                                                    <button
                                                        className="btn btn-sm btn-primary"
                                                    >move</button>
                                                    <button
                                                        className="btn btn-sm btn-primary"
                                                    >edit</button>
                                                </td>

                                            </tr>)}
                                        </tbody>
                                    </table>
                                    {/* <p>{JSON.stringify(pdtInfo.chkItms)}</p> */}
                                </div>;
                            }

                            const {
                                Component:PdtList,
                                loading:TblListLoading,
                                error:TblListError,
                                invalidate:invalidatePdtList,
                                setActiveRcdId,
                                setListType
                            } = regUse(useRcdList({
                                // listType,
                                tblName:'pdts',
                                // page,
                                // rcdsPerPage,
                                // filter,
                                // searchFlds:listFldsIn,
                                // listFlds:listFldsIn,
                                listFlds:'sn,brand,brandAbbr,name,description,category__xpd__',
                                showIndex:false,
                                hideListTypeSelector:true,
                                hideListFldsSelector:true,
                                btns:{
                                    // edit: 'stdEdit',
                                    // addChild: 'stdAddChild',
                                    // delete: 'stdDelete'
                                    chkInventory: function ChkPdtInventory({rcdId, setRcdActive}){
                                        return <div>
                                            <button 
                                                type="button"
                                                className="btn btn-primary btn-sm"
                                                onClick={evt=>{
                                                    setRcdId(rcdId);
                                                    setRcdActive&&setRcdActive();
                                                    openDlgPdtInventory({});
                                                }}
                                            >check inventory</button>
                                        </div>;
                                    }
                                }
                            }));
                            return <div className="mt-3">
                                {/* <Tbl
                                    useParams={false}
                                    tblName={'pdts'}
                                    hideTitle={true}
                                    hideNewBtn={true}
                                    showPagination={true}
                                    hideListTypeSelector={true}
                                    hideListFldsSelector={true}
                                    showBtnNew={false}
                                    listFlds={'sn,brand,brandAbbr,name,description,category__xpd__'}
                                /> */}
                                <DlgPdtInventory>
                                    <PdtInventory
                                        pdtId={rcdId}
                                    ></PdtInventory>
                                </DlgPdtInventory>
                                <PdtList></PdtList>
                            </div>;
                        }
                    },
                    userInfo.user_name == "martin"&&{
                        caption: 'Query Warehouse',
                        active: activeTag == 'Query Warehouse',
                        Content:function ContentQueryPos({}){
                            const {regUse, DefaultResponse} = regUses();
                            const {data:useInvStatusData} = regUse(useInvStatus({}))
                            const {
                                    pdtsStatus,
                                    posesStatus,
                                    skidIdToPos,
                                    arrInvChkItms,
                                    getPdtCaption,
                                    tblPoses,
                                    tblPdts,

                                    MoveSkid,
                                    MovePdt

                            } = useInvStatusData || {};


                            const [refreshId, setRefreshId] = useState(0);
                            const refreshPositionList = ()=>{
                                setRefreshId(prevId=>prevId+1)
                            };


                            const [srcPosId, setSrcPosId] = useState(0);
                            const [chkItmId, setChkItmId] = useState(0);

                            const {Dialog: DlgPosInventory, openDialog:openDlgPosInventory, closeDialog:closeDlgPosInventory} = useDialog({
                                dlgTitle: 'position inventory'
                            });
                            
                            const {Dialog: DlgMoveSkidPosition, openDialog:openDlgMoveSkidPosition, closeDialog:closeDlgMoveSkidPosition} = useDialog({
                                dlgTitle: 'move skid'
                            });

                            const {Dialog: DlgMovePdtPosition, openDialog:openDlgMovePdtPosition, closeDialog:closeDlgMovePdtPosition} = useDialog({
                                dlgTitle: 'move product'
                            });                            
                            // [] dialog content -- update?
                            function PosInventory({posId, posesStatus}){
                                // console.log('posesStatus:', posesStatus);
                                const posStatus = posesStatus[posId] || {};
                                const posInfo = posStatus.posInfo || {};
                                const posRcd = tblPoses.rcdsById[posId] || {};
                                
                                return <div className="container">
                                    <p><strong>position sn:</strong> <span>{posRcd.sn}</span></p>
                                    <p><strong>skid id:</strong> {posInfo.skidId?<span>{posInfo.skidId}</span>:<span>{"no product on skid at this position"}<button
                                        className="btn btn-sm btn-primary ms-3"
                                        onClick={(posRcd=>evt=>{
                                            addTblRcds('poses',[
                                                {
                                                    __id: posRcd.__id,
                                                    skidId: ''
                                                }
                                            ]).then(r=>{
                                                refreshPositionList();
                                                alert(`skid at postion [${posRcd.sn}] removed.`);
                                            })
                                        })(posRcd)}
                                    >remove skid</button></span>}</p>
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>action</th>
                                                <th>product</th>
                                                <th>quantity (pc)</th>
                                                <th>quantity (dz)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(posStatus.chkItms||[]).map((chkItm, chkItmIdx)=>{
                                                const pdtRcd = tblPdts.rcdsById[chkItm.pdtId] || {};
                                                return <tr
                                                    key={chkItm.__id}
                                                >
                                                    <td>
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary btn-sm"
                                                            onClick={evt=>{
                                                                setChkItmId(chkItm.__id);
                                                                openDlgMovePdtPosition();
                                                            }}
                                                        >move to other position</button>

                                                        <button
                                                            type="button"
                                                            className="btn btn-danger btn-sm"
                                                            onClick={evt=>{
                                                                if(window.confirm('confirm deletion?')){
                                                                    delTblRcds('inventoryCheckItems', chkItm.__id).then(_=>alert('deletion done!'));
                                                                }
                                                            }}
                                                        >delete</button>
                                                    </td>
                                                    <td>{getPdtCaption(pdtRcd)}</td>
                                                    <td>{eval(chkItm.qty)*(chkItm.unit=='DZ'?12:1)}</td>
                                                    <td>{eval(chkItm.qty)/(chkItm.unit=='PC'?12:1)}</td>
                                                </tr>;
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            }

                            const {
                                Component:PosList,
                                loading:TblListLoading,
                                error:TblListError,
                                invalidate:invalidatePosesList,
                                setActiveRcdId,
                                setListType
                            } = regUse(useRcdList({
                                // listType,
                                tblName:'poses',
                                // page,
                                // rcdsPerPage,
                                // filter,
                                // searchFlds:listFldsIn,
                                // listFlds:listFldsIn,
                                listFlds:'sn,brand,brandAbbr,name,description,category__xpd__',
                                showIndex:false,
                                hideListTypeSelector:true,
                                hideListFldsSelector:true,
                                reset: [refreshId],
                                btns:{
                                    // edit: 'stdEdit',
                                    // addChild: 'stdAddChild',
                                    // delete: 'stdDelete'
                                    chkPos: {
                                        generator: ({rcd})=>{
                                            if(rcd.skidId){
                                                return function ChkPosInventory({rcdId, setRcdActive}){
                                                    return <button 
                                                            type="button"
                                                            className="btn btn-primary btn-sm"
                                                            onClick={evt=>{
                                                                setSrcPosId(rcdId);
                                                                setRcdActive&&setRcdActive()
                                                                openDlgPosInventory();
                                                            }}
                                                        >check position</button>;
                                                }
                                            }
                                        }
                                    },
                                    moveSkid: {
                                        generator: ({rcd})=>{
                                            if(rcd.skidId){
                                                return function MoveSkidTo({rcdId, setRcdActive}){
                                                    return <button 
                                                        type="button"
                                                        className="btn btn-primary btn-sm ms-1"
                                                        onClick={evt=>{
                                                            // [] pos id
                                                            setSrcPosId(rcdId);
                                                            setRcdActive&&setRcdActive()
                                                            openDlgMoveSkidPosition();
                                                        }}
                                                    >move skid</button>;
                                                }
                                            }
                                        }
                                    }

                                }
                            }));

                            return <DefaultResponse>
                                <div className="container">
                                    <DlgPosInventory>
                                        <PosInventory
                                            posId={srcPosId}
                                            posesStatus={posesStatus}
                                        ></PosInventory>
                                    </DlgPosInventory>

                                    <DlgMoveSkidPosition>
                                        <span>move skid to</span>
                                        <MoveSkid
                                            srcPosId={srcPosId}
                                            refreshPositionList={refreshPositionList}
                                        ></MoveSkid>
                                    </DlgMoveSkidPosition>

                                    <DlgMovePdtPosition>
                                        <span>move product</span>
                                        <MovePdt
                                            chkItmId={chkItmId}
                                            refreshPositionList={refreshPositionList}
                                            invalidatePosesList={invalidatePosesList}
                                            closeDialog={closeDlgMovePdtPosition}
                                        ></MovePdt>
                                    </DlgMovePdtPosition>

                                    <PosList></PosList>
                                </div>
                            </DefaultResponse>

                        }
                    },
                    userInfo.user_name == "martin"&&{
                        caption: 'Take Products',
                        active: activeTag == 'Take Products',
                        Content:function ContentTakePdtsFromInventory({}){
                            const {regUse, DefaultResponse} = regUses();
                            const {data:useInvStatusData} = regUse(useInvStatus({}));
                            const {
                                    pdtsStatus,
                                    posesStatus,
                                    skidIdToPos,
                                    arrInvChkItms,
                                    getPdtCaption,
                                    tblPoses,
                                    tblPdts,

                                    MoveSkid,
                                    MovePdt

                            } = useInvStatusData || {};

                            const pdtsInfo = [
                                {
                                    pId: 45,
                                    qty: 30,
                                    unit: 'PC'
                                },
                                {
                                    pId: 46,
                                    qty: 30,
                                    unit: 'PC'
                                },
                                {
                                    pId: 195,
                                    qty: 30,
                                    unit: 'PC'
                                },
                                {
                                    pId: 198,
                                    qty: 30,
                                    unit: 'PC'
                                }
                            ]

                            const compId = randomUUID()
                            return <DefaultResponse>
                                <div className="container">
                                    <div className="accordion accordion-flush" id={compId}>
                                        {pdtsInfo.map((pdtInfo, pdtInfoIdx)=>{
                                            const itemId = `${compId}-${pdtInfoIdx}`
                                            const pdt = ((tblPdts||{}).rcdsById||{})[pdtInfo.pId] || {};
                                            return <div className="accordion-item"
                                                key={pdtInfoIdx}
                                            >
                                                <h2 className="accordion-header" id={`${itemId}-heading`}>
                                                <button
                                                    className="accordion-button collapsed"
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target={`#${itemId}-body`}
                                                    aria-expanded="false"
                                                    aria-controls="flush-collapseOne"
                                                >
                                                    {pdt.sn}-{pdt.name}
                                                </button>
                                                </h2>
                                                <div id={`${itemId}-body`} 
                                                    className="accordion-collapse collapse"
                                                    aria-labelledby={`${itemId}-heading`}
                                                    data-bs-parent={`#${compId}`}>
                                                    <div className="accordion-body">{pdtInfo.body}</div>
                                                </div>
                                            </div>
                                        })}
                                    </div>
                                </div>
                            </DefaultResponse>

                        }
                    }
                ].filter(a=>a)}
            ></WWTabs>
        </div>

    </div>
}

export default function InventoryQuery(){
    return <LoginProvider>
        <InventoryQueryContent></InventoryQueryContent>
    </LoginProvider>;
}